import React, { createContext, useContext, useState } from "react";
import { TripData, TripContextType } from "../types";

const initialTripData: TripData = {
  tripId: null,
  vehicle: null,
  tripBasic: null,
  previousTrip: {
    id: "",
    advanceBalance: "0",
    advancePayment: "0",
    balanceRecoveredAmount: "0",
  },
  route: null,
};

const TripContext = createContext<TripContextType | undefined>(undefined);

export const TripProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [tripData, setTripData] = useState<TripData>(initialTripData);

  const updateTripData = (section: keyof TripData, data: any) => {
    setTripData((prev) => ({
      ...prev,
      [section]: data,
    }));
  };

  const resetTripData = () => {
    setTripData(initialTripData);
  };

  return (
    <TripContext.Provider value={{ tripData, updateTripData, resetTripData }}>
      {children}
    </TripContext.Provider>
  );
};

export const useTripContext = () => {
  const context = useContext(TripContext);
  if (context === undefined) {
    throw new Error("useTripContext must be used within a TripProvider");
  }
  return context;
};
